import { render, staticRenderFns } from "./GBDay.vue?vue&type=template&id=2e30ef1e&"
import script from "./GBDay.vue?vue&type=script&lang=js&"
export * from "./GBDay.vue?vue&type=script&lang=js&"
import style0 from "./GBDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports